var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H7.82999L12.71 6.12001C13.1 5.73001 13.1 5.09001 12.71 4.70001C12.6175 4.6073 12.5076 4.53375 12.3866 4.48357C12.2656 4.43339 12.136 4.40756 12.005 4.40756C11.874 4.40756 11.7443 4.43339 11.6234 4.48357C11.5024 4.53375 11.3925 4.6073 11.3 4.70001L4.70999 11.29C4.61728 11.3825 4.54373 11.4924 4.49355 11.6134C4.44337 11.7344 4.41754 11.864 4.41754 11.995C4.41754 12.126 4.44337 12.2557 4.49355 12.3766C4.54373 12.4976 4.61728 12.6075 4.70999 12.7L11.3 19.29C11.3926 19.3826 11.5025 19.456 11.6234 19.5061C11.7444 19.5562 11.8741 19.582 12.005 19.582C12.1359 19.582 12.2656 19.5562 12.3865 19.5061C12.5075 19.456 12.6174 19.3826 12.71 19.29C12.8026 19.1974 12.876 19.0875 12.9261 18.9665C12.9762 18.8456 13.002 18.7159 13.002 18.585C13.002 18.4541 12.9762 18.3244 12.9261 18.2035C12.876 18.0825 12.8026 17.9726 12.71 17.88L7.82999 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.94de6f27201a2b757d697f124082c5fc.svg";
export { ForwardRef as ReactComponent };